import {attributesToProps, Element as ParserElement} from 'html-react-parser';
import {has} from 'lodash';
import {Fragment} from 'react';

import {useClientSession} from 'hooks';
import {dynamicContentUtils} from 'utils';

type Props = {
    node: ParserElement;
    show?: boolean;
    children?: React.ReactNode;
    'lang-show'?: string;
    'lang-hide'?: string;
    [key: string]: any;
}

/* eslint-disable react/jsx-no-useless-fragment */
export const NodeElement: React.FC<Props> = ({node, children = null, show = true, ...rest}: Props) => {
    const Tag = node.tagName as keyof JSX.IntrinsicElements;
    const replace = has(node.attribs, 'replace');
    const props = attributesToProps(node.attribs);
    const {localParticipant} = useClientSession();

    if (!dynamicContentUtils.isMatchLanguage(node)) {
        return null;
    }

    if (!dynamicContentUtils.isMatchRole(node, localParticipant?.role)) {
        return null;
    }

    // returning <Fragment /> means to remove an element
    return !show ? <Fragment /> :
        (replace ? <Fragment>{children}</Fragment> : <Tag {...props} {...rest}>{children}</Tag>);
};
